import { makeAutoObservable, runInAction } from 'mobx'
import { apiService } from '@/services/Api'
import { ServerOptions } from '@/services/Api/generated'

export class ServerOptionsStore {
  options: Required<ServerOptions> = {
    PASSWORD_MIN_LENGTH: 8,
    TRADE_MARK_IMAGE_MAX_SIZE: 1048576, // 1MB
    TRADE_MARK_IMAGE_MIME_TYPES:
      'image/jpeg,image/jpg,image/png,image/webp,image/tiff',
    CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH: 8,
    ALLOWED_DOCUMENT_MIME_TYPES:
      'image/jpeg,image/jpg,image/png,image/webp,image/tiff,application/pdf',
    ALLOWED_DOCUMENT_MAX_SIZE: 1048576 * 10, // 10 MB
    ALLOWED_MKTU_MIME_TYPES:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ALLOWED_MKTU_MAX_SIZE: 1048576 * 10, // 10 MB
    MIN_SUGGEST_LENGTH: 3,
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async get() {
    try {
      const response = await apiService.general.getServerOptions()
      if (response.status) {
        runInAction(() => {
          for (const key in response.data.values) {
            const value = response.data.values[key]
            if (value != null && value.toString().length != 0) {
              this.options[key] = value
            }
          }
        })
      }
    } catch {}
  }
}
